import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"
import LoginGlobal from "../data/LoginGlobal"
import Withdraw from "../transactions/Withdraw"

export default function FastCashoutGuarantee({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const data = promotionsData.find(
    (promo) => promo.title === "Fast Cashout Guarantee"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isDepositOpen, setIsDepositOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Fast Cashout Guarantee</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>{" "}
              /<span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1> Fash Cashout Guarantee </h1>
                  <h2> Get Up to ₱1000 if We're Late! </h2>
                  <div className="promotion-tnc-period">
                    <strong> Event Period: </strong>
                    <span> May 18 (12PM) - June 1 (12PM) </span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong> Terms and Conditions </strong>
                  <ol>
                    <li>
                      Open to{" "}
                      <b>
                        {" "}
                        all verified members with complete and valid
                        account{" "}
                      </b>{" "}
                      details.
                    </li>
                    <li>
                      Members are{" "}
                      <b>
                        {" "}
                        required to submit proof that they did not receive their
                        withdrawal,{" "}
                      </b>
                      which can be in the form of a screenshot or screen
                      recording.
                    </li>
                    <li>One compensation per member per day.</li>
                    <li>
                      Applies to successfully{" "}
                      <b>
                        {" "}
                        required to submit proof that they did not receive their
                        withdrawal.
                      </b>
                    </li>
                    <li>
                      Any <b> delay occured from provider side </b> like any
                      e-wallet or bank's maintenance or delay will not be
                      compensated.
                    </li>
                    <li>
                      A withdrawal is <b> not valid for compensation </b> if the
                      receiving bank fails to receive it within 3 to 5 banking
                      days from FGH’s successful processing with banks notice.
                      If non-receipt extends beyond 5 banking days (i.e., from
                      the 6th day onward), the withdrawal is considered{" "}
                      <b> valid for compensation. </b>
                    </li>
                    <li>
                      Any withdrawal delay caused by the player exceeding their
                      incoming wallet or bank limit shall{" "}
                      <b> not be considered valid. </b>
                    </li>
                    <li>
                      If withdrawal is processed via <b> CASH DEPOSIT </b> it is
                      not included.
                    </li>
                    <li>
                      We have the rights to decline to give the free credits
                      promo upon evaluation like intentionally delaying the
                      withdrawal
                    </li>
                    <li>
                      FGH reserves the right to modify, suspend, or terminate
                      the promotion at any time without prior notice.
                    </li>
                  </ol>
                  <strong>Compensation if there's a delay</strong>
                  <ol>
                    <li>
                      If the withdrawal exceeds the guaranteed 18-minute
                      processing time, the following free credits will be
                      credited:
                    </li>
                  </ol>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <th> Withdrawal Amount </th>
                        <th> Free Credits </th>
                      </thead>
                      <tbody>
                        <tr>
                          <td> ₱200 - ₱4,999 </td>
                          <td>
                            <b> ₱200 free credits </b>
                          </td>
                        </tr>
                        <tr>
                          <td> ₱5,000 – ₱49,999 </td>
                          <td>
                            {" "}
                            <b> ₱500 free credits </b>{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ₱50,000 </td>
                          <td>
                            {" "}
                            <b> ₱1,000 free credits </b>{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {!isAppPromo && (
                    <>
                      <div className="promotion-tnc-cta">
                        {isLoggedIn ? (
                          <button
                            type="button"
                            className="promotion-cta-btn"
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsDepositOpen(true)}
                          >
                            Withdraw Now
                          </button>
                        ) : (
                          <LoginGlobal
                            label="Withdraw Now"
                            btnClass="promotion-cta-btn"
                            onlyBtn={true}
                          />
                        )}
                      </div>
                      {isDepositOpen &&
                        createPortal(
                          <div className="modal-portal">
                            <Withdraw
                              onClose={() => setIsDepositOpen(false)}
                              defaultBonusName="New Member Package Bonus"
                            />
                          </div>,
                          document.body
                        )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
